import Helper from './Helper';

class Cv {
  constructor(config = {}) {
    this.cvs = Array.prototype.slice.call(document.querySelectorAll('.lc-cv'));
    this.isTabletUp = window.matchMedia('(min-width: 768px)').matches;

    if (this.cvs && this.cvs.length !== 0) {
      this.bindEvents();
    }

    // Update isTabletUp on resize
    window.addEventListener('resize', () => {
      this.isTabletUp = window.matchMedia('(min-width: 768px)').matches;
    });
  }

  toggleCvs(clickedCv, shouldOpen) {
    this.cvs.forEach(cv => {
      const content = cv.querySelector('.lc-cv__content');

      if (cv === clickedCv) {
        // Toggle only the clicked item
        if (shouldOpen) {
          Helper.slideOpen(content);
          cv.classList.add('open');
        } else {
          Helper.slideClose(content);
          cv.classList.remove('open');
        }
      } else {
        // Close all others
        Helper.slideClose(content);
        cv.classList.remove('open');
      }
    });
  }

  bindEvents() {
    this.cvs.forEach(el => {
      const buttons = el.querySelectorAll('.lc-cv__button');

      buttons.forEach(button => {
        button.addEventListener('click', () => {
          const shouldOpen = !el.classList.contains('open');
          this.toggleCvs(el, shouldOpen); // Pass only the clicked one
        });
      });
    });
  }
}

export default Cv;
